module.exports = __webpack_public_path__ + "img/2-r@2x.fe23ba87.jpg";